// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 863) return "content/plugin-static-data-manager/850cd0a0d7ccdd83af52f85d5cf34e06.js";
	if (chunkId === 972) return "content/plugin-static-data-manager/5fb446a502f2f8972145ee701341f2e7.js";
	if (chunkId === 221) return "content/plugin-static-data-manager/9ee3d807ee7094345ccfad0339501c26.js";
	if (chunkId === 247) return "content/plugin-static-data-manager/446e52859ed3766b35048f917d179e9c.js";
	if (chunkId === 770) return "content/plugin-static-data-manager/f983865b9ce269f0843169ee7225d78b.js";
	if (chunkId === 33) return "content/plugin-static-data-manager/e06f125fd5143cb9ef1a7e3799fb1b5e.js";
	if (chunkId === 722) return "content/plugin-static-data-manager/894d83c901861b59c275d16b6adfa86d.js";
	if (chunkId === 211) return "content/plugin-static-data-manager/c12b6427f94623256035b484b6c610f4.js";
	if (chunkId === 644) return "content/plugin-static-data-manager/e976dc2c50e2ea0c00d7755bd3af805a.js";
	if (chunkId === 561) return "content/plugin-static-data-manager/734e29888d926da9fac72be747b3ec83.js";
	// return url for filenames based on template
	return undefined;
};